export default {
    Form: {
        Required: 'Este campo é obrigatório',
        Invalid: 'Desculpe, mas este campo é inválido',
    },
};
